export default "__VITE_PUBLIC_ASSET__dc4097ec__"